import React from 'react';
interface SectionLabelProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function SectionLabel({
  children,
  tone = 'light'
}: SectionLabelProps) {
  const toneClasses = tone === 'dark' ? 'bg-sun/15 text-sun ring-sun/30' : 'bg-orange/10 text-orange ring-orange/25';
  return <p className={`mx-auto flex w-fit items-center gap-2 rounded-full px-3.5 py-1.5 text-center text-[9px] font-black uppercase leading-tight tracking-[0.16em] ring-1 sm:px-4 sm:text-[10px] sm:tracking-[0.2em] ${toneClasses}`} data-id="element-259" data-mp="17qqztlpcol8c">
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" data-id="element-260" data-mp="xzmmsrj8jag5" />
      {children}
    </p>;
}